import React from 'react';

interface TechnologySteeringBoardIconProps {
  color?: string;
  height?: number | string;
  width?: number | string;
  opacity?: number;
  style?: React.CSSProperties;
  className?: string;
  'aria-label'?: string;
}

const TechnologySteeringBoardIcon: React.FC<TechnologySteeringBoardIconProps> = ({
  color = '#2372b9',
  height = 14,
  width = 14,
  opacity = 1,
  style,
  className,
  'aria-label': ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewBox="0 0 640 640"
    style={{ opacity, ...style }}
    className={className}
    aria-label={ariaLabel}
    role={ariaLabel ? 'img' : 'presentation'}
  >
    {/* Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com
        License - https://fontawesome.com/license/free
        Copyright 2026 Fonticons, Inc. */}
    <path
      fill={color}
      d="M320 64C355.3 64 384 92.7 384 128C384 163.3 355.3 192 320 192C284.7 192 256 163.3 256
         128C256 92.7 284.7 64 320 64zM416 376C416 401 403.3 423 384 435.9L384 480L256 480L256 435.9C236.7
         423 224 401 224 376L224 336C224 283 267 240 320 240C373 240 416 283 416 336L416 376zM432 480L432
         452.7C451.9 430.2 464 400.5 464 368L464 336C464 309.3 456.7 284.4 444.1 262.9C455.2 258.4 467.3
         256 480 256C533 256 576 299 576 352L576 384C576 407.7 563.1 428.4 544 439.4L544 480L432 480zM96
         439.4C76.9 428.4 64 407.7 64 384L64 352C64 299 107 256 160 256C172.7 256 184.8 258.5 195.9 262.9C183.3
         284.3 176 309.3 176 336L176 368C176 400.5 188.1 430.1 208 452.7L208 480L96 480L96 439.4zM160 96C190.9
         96 216 121.1 216 152C216 182.9 190.9 208 160 208C129.1 208 104 182.9 104 152C104 121.1 129.1 96
         160 96zM480 96C510.9 96 536 121.1 536 152C536 182.9 510.9 208 480 208C449.1 208 424 182.9 424 152C424
         121.1 449.1 96 480 96zM56 528L584 528C597.3 528 608 538.7 608 552C608 565.3 597.3 576 584 576L56
         576C42.7 576 32 565.3 32 552C32 538.7 42.7 528 56 528z"
    />
  </svg>
);

export default TechnologySteeringBoardIcon;
